const urlPrefix = 'digital-learning'

const pages = {
  index: {
    'pt-br': `/hotmartacademy`,
    en: `/${urlPrefix}`,
    es: `/${urlPrefix}`,
    'es-es': `/${urlPrefix}`,
    'es-co': `/${urlPrefix}`,
    'es-mx': `/${urlPrefix}`,
    co: `/${urlPrefix}`,
    mx: `/${urlPrefix}`,
    la: `/${urlPrefix}`,
  },
  'thank-you': {
    'es-co': `/${urlPrefix}/gracias`,
    'es-mx': `/${urlPrefix}/gracias`,
    co: `/${urlPrefix}/gracias`,
    mx: `/${urlPrefix}/gracias`,
    la: `/${urlPrefix}/gracias`,
  },
}

export default pages
